import { BuiSplitView } from "@btnet/blueprint-components";

import "./BTSplitView.less";
import type { IBTSplitViewProps } from "./BTSplitView.types";
import { DetailFullWidthProvider } from "./DetailFullWidthContext";
import { useBTSplitView } from "./useBTSplitView";

export function BTSplitView(props: IBTSplitViewProps) {
  const {
    containerRef,
    isMeasured,
    containerClassName,
    groupProps,
    listPanelProps,
    detailPanelProps,
    handleProps,
    isDetailFullWidth,
  } = useBTSplitView(props);

  return (
    <div ref={containerRef} className={containerClassName}>
      {isMeasured && (
        <BuiSplitView {...groupProps}>
          <BuiSplitView.Panel {...listPanelProps}>
            {props.list}
          </BuiSplitView.Panel>
          <BuiSplitView.Handle {...handleProps} />
          <BuiSplitView.Panel {...detailPanelProps}>
            <DetailFullWidthProvider isFullWidth={isDetailFullWidth}>
              {props.detail}
            </DetailFullWidthProvider>
          </BuiSplitView.Panel>
        </BuiSplitView>
      )}
    </div>
  );
}
